"use client";

import { useEffect, useMemo, useState } from "react";
import useAllLeagues from "@/hooks/useAllLeagues";
import { KbvPluginService } from "@/services/kbvPluginService";
import LeagueFilterV27QuickChips from "./LeagueFilterV27QuickChips";

const QUICK_LEAGUE_COUNT = 12;

export default function LeagueFilterV27QuickChipsBar({
  selectedIds = [],
  onChange,
  className = "",
}) {
  const { leagues } = useAllLeagues();
  const [hotLeagues, setHotLeagues] = useState([]);

  useEffect(() => {
    let active = true;

    const fetchHotLeagues = async () => {
      const data = await KbvPluginService.getHotLeagues({
        page: 1,
        limit: QUICK_LEAGUE_COUNT,
        fields: "id,name,logo,slug,nameVN",
      });
      if (!active) return;
      setHotLeagues(Array.isArray(data?.data) ? data.data : data || []);
    };

    fetchHotLeagues();
    return () => {
      active = false;
    };
  }, []);

  const normalizedLeagues = useMemo(
    () =>
      (leagues || []).map((l) => ({
        ...l,
        country: l.country || l.countryName || "Khác",
      })),
    [leagues],
  );

  const quickLeagueChips = useMemo(
    () =>
      (hotLeagues?.length
        ? hotLeagues
        : normalizedLeagues.slice(0, QUICK_LEAGUE_COUNT)
      ).map((league) => ({
        ...league,
        id: Number(league.id),
      })),
    [hotLeagues, normalizedLeagues],
  );

  const handleQuickChipClick = (leagueId) => {
    const onlyThis =
      selectedIds.length === 1 &&
      String(selectedIds[0]) === String(leagueId);
    if (onlyThis) {
      onChange?.([]);
    } else {
      onChange?.([leagueId]);
    }
  };

  if (!quickLeagueChips.length) return null;

  return (
    <div className={className}>
      <LeagueFilterV27QuickChips
        quickLeagueChips={quickLeagueChips}
        selectedIds={selectedIds}
        onQuickChipClick={handleQuickChipClick}
      />
    </div>
  );
}
